import { RECRUITERCANDIDATEDOMAIN } from "../../ENVIRONMENT";

// api for recruiter domain list
function recdomainList(token) {
  const response = fetch(RECRUITERCANDIDATEDOMAIN, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${
        token ? token : sessionStorage.getItem("token")
      }`,
    },
  });
  return response;
}

export { recdomainList };
